import * as React from "react";
import { OAuthCallback } from "@/new-pages/oauth/callback";
import type { RouteObject } from "react-router-dom";

import { AuthGuard } from "@/components/auth/auth-guard";

// No dashboard chrome: the page shows inside the provider popup. `complete` needs the user session.
export const route: RouteObject = {
	path: "oauth/callback",
	element: (
		<AuthGuard>
			<OAuthCallback />
		</AuthGuard>
	),
};
